/**
 * About Section Accordion Implementation
 *
 * This code implements an accordion-style interaction for an About section,
 * where clicking on titles expands/collapses their corresponding descriptions.
 *
 * Dependencies:
 * - jQuery (required for DOM manipulation and animations)
 *
 * HTML Structure Expected:
 * - Elements with class "about__accordion-title" for clickable headers
 * - Elements with class "about__accordion-description" for content sections
 *
 * Functionality:
 * 1. When a title is clicked:
 *    - If not active:
 *      * Deactivates any currently active title
 *      * Activates the clicked title
 *      * Closes all descriptions
 *      * Opens the description corresponding to the clicked title
 *    - If already active:
 *      * Deactivates the title
 *      * Closes its description
 *
 * 2. Animations:
 *    - Uses jQuery's slideUp/slideDown with 300ms duration
 *    - stop() is called to prevent animation queuing
 *
 * 3. Event Handling:
 *    - Initializes on page load
 *    - Re-initializes when Shopify section is loaded (for theme editor compatibility)
 */

(function () {
  /**
   * Initializes the accordion functionality
   * Sets up click handlers for accordion titles
   */
  const initProductAccordion = () => {
    $('.about__accordion-title').click(function () {
      if (!$(this).hasClass('active')) {
        // Handle opening a new section
        $('.about__accordion-title.active').removeClass('active');
        $(this).addClass('active');
        $('.about__accordion-description').stop().slideUp(300);
        $(this)
          .siblings('.about__accordion-description')
          .eq($(this).index())
          .stop()
          .slideDown(300);
      } else {
        // Handle closing the current section
        $(this).removeClass('active');
        $(this).siblings('.about__accordion-description').stop().slideUp(300);
      }
    });
  };

  // Initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
  });

  // Initial initialization
  initProductAccordion();
})();
